import script from "./modal_add.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal_add.vue?vue&type=script&setup=true&lang=ts"

import "./modal_add.vue?vue&type=style&index=0&id=2c9684d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c9684d5"]])

export default __exports__